module.exports = __webpack_public_path__ + "static/media/logout.a79ba97d.svg";